import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { EntityTypes } from '../entity/entity-types';
import { ModelListParams } from './models/model-list-params';
import { Model } from './models/model';
import { StoreBaseService } from '../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class ModelService
  extends StoreBaseService<Model, Model, ModelListParams> {

  get entityType(): string {
    return EntityTypes.model;
  }

  get resourceName(): string {
    return 'model';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
